import React, { Component } from 'react';
import { NutritionStringToObject } from '../../../../../lib/helper.js';
import { uniqueId } from 'lodash';

export default class Nutrition extends Component {
  render() {
    const formatArray = nutrition => {
      const formattedArray = {};
      const length = nutrition.length;
      for (let i = 0; i < length; i++) {
        if (!formattedArray[nutrition[i].name]) {
          formattedArray[nutrition[i].name] = [];
        }

        formattedArray[nutrition[i].name].push({
          unit: nutrition[i].unit,
          value: nutrition[i].value,
          formattedName: `${nutrition[i].value}${nutrition[i].unit}`,
        });
      }
      return formattedArray;
    };

    const nutritionList = formatArray(
      NutritionStringToObject(this.props.nutritionInfo)
    );

    const list = [];
    return (
      <div className="itemNutrition">
        {Object.keys(nutritionList).forEach(name => {
          const data = nutritionList[name];
          list.push(
            <div
              className="pull-right"
              key={uniqueId('nutrition-information-')}
            >
              <div className="olo-client-theme-color">
                <b>{name}</b>
              </div>
              {data.map(item => {
                return (
                  <div key={uniqueId('line-item')}>{item.formattedName}</div>
                );
              })}
            </div>
          );
        })}
        {list}
      </div>
    );
  }
}

export const NutritionPannel = props => {
  return (
    <div className="col-md-12 col-sm-12 col-lg-12 col-xs-12 nutritionContainer">
      <div className="line-style "> </div>
      <div
        className="col-md-4 "
        style={{ paddingLeft: '0px', paddingTop: '5px' }}
      >
        <div className="sectionTitle">
          {props.currentItem.ingredients !== null ? props.header : null}
        </div>
        <div style={{ paddingTop: '5px' }}>
          <span style={{ lineHeight: '1.7em' }}>
            {props.currentItem.ingredients !== ''
              ? props.currentItem.ingredients
              : null}
          </span>
        </div>
      </div>
      <div className="col-md-8 nutritionSection itemN">
        <div className="sectionTitle olo-client-theme-color">
          <Nutrition
            nutritionInfo={props.currentItem.nutrition[0]}
            paddingBottom="5px"
          />
        </div>

        <Nutrition
          nutritionInfo={props.currentItem.nutrition}
          paddingBottom="5px"
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/Nutrition.jsx